import React from "react";
import Table from "../Shared/Table";
import {Card, CardBody, CardHeader, CardTitle, Row, Col, Button} from "reactstrap";

import { pbxGroup } from "core/UrlEndpoints";
import { useHistory } from "react-router-dom";

const PbxGroupList = () => {
    const history = useHistory();

    return (
        <>
            <Row>
                <Col xs={12} md={12}>
                    <Card>
                        <CardHeader>
                            <CardTitle tag="h4">Pbx Groups</CardTitle>
                            <Button
                                color="primary"
                                onClick={() => history.push(`pbxgroups/add`)}>
                                Add
                            </Button>
                        </CardHeader>
                        <CardBody>
                            <Table
                                url={pbxGroup}
                                pathroot={'pbxgroups'}
                                columns={[
                                    {
                                        header: "Name",
                                        accessorKey: "name",
                                    },
                                    {
                                        header: "Primary Url",
                                        accessorKey: "primaryUrl",
                                    },
                                    {
                                        header: "Backup Url",
                                        accessorKey: "backupUrl",
                                    },


                                ]}
                            />
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </>
    );
};

export default PbxGroupList;
